import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import scrollmagic from 'scrollmagic'
Vue.config.productionTip = false

new Vue({
  router,
  store,
  scrollmagic,
  render: h => h(App)
}).$mount('#app')
